import React, { useState } from 'react';
import { ReactComponent as Close } from 'assets/icons/close.svg';
import { Stencil } from '@cleartrip/bento';

function SheetHeader(props) {
	const { title, onClose, loading,align } = props;
	return (
		<div style={{direction:align()}} className='p-fixed px-4 l-0 flex-1 bb bc-neutral-100 r-0 z-20 h-13 bg-white flex flex-middle flex-between'>
			{loading ? (
				<Stencil height={20} width="60%" />
			) : (
				<>
					<h4 className='fs-4 fw-600 c-neutral-900'>{title}</h4>
					<Close onClick={onClose} className='c-secondary-500' />
				</>
			)}
		</div>
	);
}

SheetHeader.defaultProps = {
	onClose: () => {},
};
export default SheetHeader;
